import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';
import { secondaryTabsHaveId } from 'owa-tab-store';
import getPrimaryTabId from '../utils/getPrimaryTabId';

export const addLoadedItemReadingPaneViewState = mutatorAction(
    'addLoadedItemReadingPaneViewState',
    function (itemReadingPaneViewState: ItemReadingPaneViewState) {
        const itemId = itemReadingPaneViewState.itemId;
        const { loadedItemReadingPaneViewStates } = getStore();
        if (!loadedItemReadingPaneViewStates.has(itemId)) {
            loadedItemReadingPaneViewStates.set(itemId, itemReadingPaneViewState);
        }
    }
);

export const releaseOrphanedLoadedItemViewStates = mutatorAction(
    'releaseOrphanedLoadedItemViewStates',
    function () {
        const {
            loadedItemReadingPaneViewStates,
            loadingProjectionIds,
            itemPreviewPaneViewState,
            itemPrintPaneViewState,
        } = getStore();
        // Release any view states that is none of the following:
        // - is held by any tabs (primary or secondary)
        // - is currently being loaded for projection popout
        // - is the item preview pane
        // - is the item print pane
        loadedItemReadingPaneViewStates.forEach((viewState, loadedItemId) => {
            if (
                !(
                    loadedItemId == getPrimaryTabId() ||
                    secondaryTabsHaveId(loadedItemId) ||
                    loadingProjectionIds?.indexOf(loadedItemId) != -1 ||
                    loadedItemId == itemPreviewPaneViewState?.itemId ||
                    loadedItemId == itemPrintPaneViewState?.itemId
                )
            ) {
                loadedItemReadingPaneViewStates.delete(loadedItemId);
            }
        });
    }
);

export const releaseLoadedItemViewState = mutatorAction(
    'releaseLoadedItemViewState',
    function (itemId: string) {
        getStore().loadedItemReadingPaneViewStates.delete(itemId);
    }
);
